import { useEffect } from "react";

interface StyledFaviconOptions {
  rootApiPath?: string;
  fallbackFaviconUrl?: string;
}

export function useStyledFavicon({ rootApiPath = "", fallbackFaviconUrl = "/favicon.ico" }: StyledFaviconOptions = {}) {
  useEffect(() => {
    (async () => {
      const link = (document.querySelector("link[rel~='icon']") as HTMLLinkElement) || document.createElement("link");

      // Start with empty favicon
      link.href = "";
      document.head.appendChild(link);

      try {
        const response = await fetch(`${rootApiPath}/v1/style/assets/Favicon/file`);
        const blob = await response.blob();
        const objectUrl = URL.createObjectURL(blob);
        link.href = objectUrl;
      } catch {
        link.href = fallbackFaviconUrl;
      }
    })();
  }, [rootApiPath, fallbackFaviconUrl]);
}
